<template>
    <v-row justify="center" class="mr-0 mt-2 mb-2">
        <v-btn v-if="isTubeSeries" @click="selectAllBatches" color="primary" size="x-small"
            >Select All</v-btn
        >
        <v-btn
            v-if="!isTubeSeries"
            @click="assignAllBatches"
            color="primary"
            size="x-small"
            class="mx-3"
            >Assign All</v-btn
        >
        <v-btn
            v-if="enableMultiAssign"
            @click="assignMultipleBatches"
            color="primary"
            size="x-small"
            class="mx-3"
        >
            Auto-Assign Selected
        </v-btn>
        <v-btn @click="clearSelection" color="primary" size="x-small" class="mx-3">Clear</v-btn>
    </v-row>
    <v-row class="mt-2 ml-2">
        <v-list
            :items="batches"
            item-title="name"
            selectable
            select-strategy="multiple"
            @update:selected="onSelect"
            return-object
            :selected="selected"
        ></v-list>
    </v-row>
</template>
<script>
import { map } from "lodash";
import { mapActions, mapGetters } from "vuex";
import { defineComponent } from "vue";
import { fetchBatchesForFermenterRun } from "@/services/fermenterRuns/fermenterRunAPI";

export default defineComponent({
    name: "BatchList",
    emits: ["batchesSelected"],
    props: {
        experiment: Object,
        batchType: String,
    },
    data() {
        return {
            batches: [],
            selected: [],
        };
    },
    async created() {
        this.batches = await this.fetchBatches(this.experiment.exp);
    },
    computed: {
        ...mapGetters("plateCreate", ["isTubeSeries"]),
        enableMultiAssign() {
            return this.selected.length > 0 && !this.isTubeSeries;
        },
    },
    methods: {
        ...mapActions("plateCreate", ["setActiveCondition", "setSampleConditionSelection"]),
        async fetchBatches(experimentCode) {
            return fetchBatchesForFermenterRun(experimentCode, this.batchType);
        },
        onSelect(selected) {
            this.selected = selected;
            if (this.selected && this.selected.length) {
                this.selected.forEach((batch) => {
                    batch.experiment_code = this.experiment.exp;
                    batch.experiment_id = this.experiment.id;
                    batch.type = "Batch";
                });
                this.setActiveCondition(this.selected[0]);
            } else {
                this.setActiveCondition(null);
            }
            this.$emit("batchesSelected", this.selected);
            this.setSampleConditionSelection(this.selected);
        },
        async selectAllBatches() {
            this.selected = this.batches;
            this.onSelect(this.selected);
        },
        async assignAllBatches() {
            this.selected = this.batches;
            this.onSelect(this.selected);
            this.$emit("openOptionsMenu", "assignAll");
        },
        async assignMultipleBatches() {
            this.onSelect(this.selected);
            this.$emit("openOptionsMenu", "assignMultiple");
        },
        clearSelection() {
            this.selected = [];
            this.onSelect(this.selected);
        },
    },
    watch: {
        experiment: {
            handler: async function (newVal) {
                this.batches = await this.fetchBatches(newVal.exp);
            },
            deep: true,
        },
        batchType: {
            handler: async function (newVal) {
                this.batches = await this.fetchBatches(this.experiment.exp);
            },
            deep: true,
        },
    },
});
</script>
